import { invokeApi } from "../bl_libs/invokeApi";
import { LOCAL_STORAGE_KEYS } from "../utils/constants";

export const PaymantInfoService = async () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dqseal_client/billing/billing_info',
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    return await invokeApi(requestObj);
};



// Stripe 
export const CreatePaymentIntentService = async (data) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dqseal_client/billing/create_payment_intent',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
    };
    requestObj['postData'] = data;

    return await invokeApi(requestObj);
};

export const ValidatePromoService = async (data) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dqseal_client/billing/validate_promo',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
    };
    requestObj['postData'] = data;

    return await invokeApi(requestObj);
};

export const UpdateBillingOrgService = async (data) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dqseal_client/billing/update_payment_billing',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
    };
    requestObj['postData'] = data;

    return await invokeApi(requestObj);
};

export const subscribeService = (plan_key) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/subscription/subscribe',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { plan_key },
    };
    return invokeApi(requestObj);
};

export const getSubscriptionStatusService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/subscription/status',
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
    };
    return invokeApi(requestObj);
};

export const changePlanService = (new_plan_key) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/subscription/plan/change',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { new_plan_key },
    };
    return invokeApi(requestObj);
};

export const cancelSubscriptionService = (immediate = false) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/subscription/cancel',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { immediate },
    };
    return invokeApi(requestObj);
};

// Resumes a subscription that was set to cancel at period end (un-cancels it).
// This does NOT create a new subscription — it updates cancel_at_period_end to false.
export const resumeSubscriptionService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/subscription/resume',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: {},
    };
    return invokeApi(requestObj);
};

export const getCreditBalanceService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/credits/balance',
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
    };
    return invokeApi(requestObj);
};

export const getCreditLedgerService = (params) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/credits/ledger',
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
        queryParams: params,
    };
    return invokeApi(requestObj);
};

// ── DQ Token (DQT) wallet ───────────────────────────────────────────────────
// DQT is a separate unit from credits: the currency a partner holds, converted one
// way into credits at the price on its plan. See my-dq-api
// src/docs/DQ Token, Credits & Licences — Technical Architecture.md.

// GET — { dqt_visible, dqt_balance, credit_balance, credit_price_dqt, can_convert, convert_blocked_reason, ... }
export const getDqtWalletService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/dqt/wallet',
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
    };
    return invokeApi(requestObj);
};

// GET — paginated DQT history. params: { page, limit, transaction_type }
export const getDqtLedgerService = (params) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/dqt/ledger',
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
        queryParams: params,
    };
    return invokeApi(requestObj);
};

// GET — learner-licence history + the seats this workspace holds unassigned.
export const getLicenceLedgerService = (params) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/licences/ledger',
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
        queryParams: params,
    };
    return invokeApi(requestObj);
};

/*
 * ── DQ Token checkout (Stripe Checkout Sessions + Adaptive Pricing) ─────────
 * The server decides what can be bought and grants DQT only when Stripe
 * reports the payment as paid.
 */

// GET — what this workspace can buy: plans sold one-time and its plan's packs.
export const getDqtCheckoutCatalogService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/checkout/catalog',
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
    };
    return invokeApi(requestObj);
};

// POST — start a checkout. { kind: 'plan', plan_key }, { kind: 'topup', amount_usd }
// for an amount the buyer chose (there are no packs), or on a direct plan
// { kind: 'topup', licences } for a number of licences.
// Returns the Checkout Session's client_secret. Owner only.
export const createDqtCheckoutService = (payload) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/checkout/create',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: payload,
    };
    return invokeApi(requestObj);
};

// POST — pay by bank transfer. Same payload as createDqtCheckoutService. Returns
// { order (with invoice_no — the reference to quote), instructions (bank details) }.
// Nothing is granted until DQ approves the uploaded proof. Owner only.
export const createDqtWireOrderService = (payload) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/wire/create',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: payload,
    };
    return invokeApi(requestObj);
};

// POST (multipart) — upload proof of a bank transfer: PDF, JPG or PNG, 10 MB.
// `Content-Type: undefined` lets the browser write the multipart boundary; the
// body is left unencrypted because e2ee would reduce FormData to "{}".
export const uploadDqtWireProofService = (order_id, file, note) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const formData = new FormData();
    formData.append('media', file);
    formData.append('order_id', order_id);
    if (note) formData.append('note', note);
    const requestObj = {
        path: '/dq_insider/dqin/billing/wire/proof',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': undefined },
        postData: formData,
    };
    return invokeApi(requestObj);
};

// GET — the caller's bank transfers and their review state, newest first.
export const getDqtWireOrdersService = (params) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/wire/list',
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
        queryParams: params,
    };
    return invokeApi(requestObj);
};

// GET — the order behind a checkout Stripe has returned from.
export const getDqtCheckoutStatusService = (session_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/checkout/status',
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
        queryParams: { session_id },
    };
    return invokeApi(requestObj);
};

export const purchaseCreditsService = (amount_credits) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/credits/purchase',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { amount_credits },
    };
    return invokeApi(requestObj);
};

export const listSavedCardsService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/cards',
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
    };
    return invokeApi(requestObj);
};

export const setupCardService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/cards/setup',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
    };
    return invokeApi(requestObj);
};

export const setPrimaryCardService = (payment_method_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/cards/set_primary',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { payment_method_id },
    };
    return invokeApi(requestObj);
};

export const removeCardService = (payment_method_id) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/cards/remove',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { payment_method_id },
    };
    return invokeApi(requestObj);
};

export const listPendingInvoicesService = () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const requestObj = {
        path: '/dq_insider/dqin/billing/invoices/pending',
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
    };
    return invokeApi(requestObj);
};

export const payPendingInvoiceService = (stripe_invoice_id, payment_method_id = null) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    const postData = { stripe_invoice_id };
    if (payment_method_id) postData.payment_method_id = payment_method_id;
    const requestObj = {
        path: '/dq_insider/dqin/billing/invoices/pay',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        postData,
    };
    return invokeApi(requestObj);
};

